const payrollSystems = [
  { label: "Simple Pay", value: "SIMPLE_PAY" },
  { label: "Sage", value: "SAGE" },
  { label: "VIP", value: "VIP" },
  { label: "Oracle", value: "ORACLE" },
  { label: "Excel Spreadsheet", value: "EXCEL" },
  { label: "Other payroll system", value: "OTHER" }
]

export default payrollSystems